@let configuration = configurationSg();

<div class="atn-space-report-unclaimed-rooms">
  <atn-ds-widget title="Configuration">
    <div class="atn-space-report-unclaimed-rooms__configuration">
      <atn-ds-select-single
        label="Format"
        [items]="formatItems"
        [value]="configuration.format"
        [required]="true"
        (valueChange)="formatChangeHandler($event)"
      />
    </div>
  </atn-ds-widget>
</div>
